/** @format */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import PercentageCircle from 'src/ui/library/PercentageCircle';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import QuestionnaireTopHeader from './QuestionnaireTopHeader';
import QuestionnaireAccordionSectionPres from './QuestionnaireAccordionSectionPres';
import { ActionsBarContainer } from 'src/ui/features/Questionnaire/containers';
import { CASES_URL, CASE_DETAIL_URL } from 'src/constants/constants.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import classNames from 'classnames';
import intl from 'react-intl-universal';
import { formatDDMMYY } from 'src/helpers/date';
import DOMPurify from 'dompurify';

const goldColor = '#f5a623';
const greenColor = '#2eb757';

const parsePercentString = value => parseInt(value, 10);

const getDescriptionText = (descriptionsArr, value) => {
  if (!descriptionsArr) {
    return '';
  }
  let descriptionText = descriptionsArr.filter(d => d.sectionName === value);
  descriptionText = descriptionText[0] ? descriptionText[0].description : '';
  return descriptionText;
};

export const QuestionnaireLandingPres = ({
  isWithinCaseDetails,
  // gettingIntroData,
  introData,
  push,
  // goBack,
  match,
  readMore,
  toggleReadMore,
  isMobile,
  welcomeMessage,
  history,
}) => {
  if (!introData) {
    return <ServiceSpinner />;
  }
  const props = { introData, push, match, readMore, toggleReadMore, isMobile, welcomeMessage, history };
  const data = introData;
  const overallProgress = parsePercentString(data.overallProgress);
  const overallProgressWithPercentage = overallProgress + '%';
  const overviewDescription = getDescriptionText(data.descriptions, intl.get('questionnaire.sectionNames.overview'));

  // business change again wanting this hardcoded
  //const whatYouNeedDescription = DOMPurify.sanitize(getDescriptionText(data.descriptions, intl.get('questionnaire.sectionNames.whatYouNeed')));

  const whatYouNeedDescription = (
    <div style={{ marginBottom: '3%' }}>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(welcomeMessage) }}></div>
    </div>
  );
  const headerDetailsObject = sessionStorage.getItem('headerDetails');
  const headerDetails = JSON.parse(headerDetailsObject);
  const caseManagerId = headerDetails.caseManagerId ? headerDetails.caseManagerId : sessionStorage.getItem('caseManagerId');
  const onClose = () => push(`${CASE_DETAIL_URL}/${caseManagerId}`);
  const showReadMoreBtn = `${overviewDescription} ${whatYouNeedDescription}`.length > 165;

  // temporary fix because business was concerned with the length of time
  // for now we will supply a hardcoded value

  return (
    <div>
      <QuestionnaireTopHeader
        isWithinCaseDetails={isWithinCaseDetails}
        title={data.questionnaireName}
        onBack={() => push(CASES_URL)}
        onClose={onClose}
        data={data}
        overallProgress={overallProgress}
      />
      <article
        className={classNames({
          'questionnaire-landing-container': true,
          'is-within-case-details': isWithinCaseDetails,
          'is-mobile': isMobile,
        })}>
        {/**clear about this below block 
        {!isWithinCaseDetails && (
          <header history={history} className="hide-mobile">
            {data.questionnaireName}
            <div className="questionnaire-status">
              <span>
                {data.questionnaireStatus && data.questionnaireStatus.includes('Unlocked') ? <LockOpenIcon /> : <LockIcon />}
                &nbsp;&nbsp;
                {data.statusMessage}
              </span>
              <span>
                <strong>{data.propertyNameEstimatedTime}</strong>&nbsp;&nbsp;
                {data.valueEstimatedTime}
              </span>
            </div>
          </header>
        )}
        {!isWithinCaseDetails && (
          <div
            className={classNames({
              'add-side-margins': true,
              'mobile-read-box': true,
              'show-more-text': readMore,
            })}>
            <Grid container spacing={0}>
              <Grid item xs={12} sm={6} md={4} lg={3} className="hide-mobile">
                <div className="overall-progress-circle">
                  <PercentageCircle
                    color={overallProgress === 100 ? greenColor : goldColor}
                    percent={overallProgress}
                    radius={100}
                    borderWidth={12}>
                    <p className="overall-progress-verbiage">
                      {overallProgressWithPercentage}
                      <br />
                      <span>{intl.get('questionnaire.overAllProgress')}</span>
                    </p>
                  </PercentageCircle>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={6}>
                {whatYouNeedDescription}
              </Grid>
            </Grid>
          </div>
        )}
        {!isWithinCaseDetails && showReadMoreBtn && (
          <div className="show-mobile read-more-btn" onClick={toggleReadMore}>
            <span className="space-after">{intl.get('questionnaire.read')}</span>
            {readMore ? intl.get('questionnaire.less') : intl.get('questionnaire.more')}
          </div>
        )}
        */}

        {!isWithinCaseDetails && (
          <div>
            <Grid container className="header-title-container">
              <Grid item xs={12} sm={12} md={6} lg={7} className={classNames({})}>
                <span className="title-header">{data.questionnaireName}</span>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={5}>
                <div className="estimation-header">
                  <span>
                    {data.questionnaireStatus && data.questionnaireStatus.includes('Unlocked') ? <LockOpenIcon /> : <LockIcon />}
                    &nbsp;&nbsp;
                    {data.statusMessage}
                  </span>
                  <span>
                    {data.propertyNameEstimatedTime}&nbsp;&nbsp;
                    {data.valueEstimatedTime}
                  </span>
                </div>
              </Grid>
            </Grid>
          </div>
        )}

        {!isWithinCaseDetails && (
          <div
            className={classNames({
              'mobile-read-box': true,
              'lobby-welcome-msg': true,
            })}>
            <Grid container>
              <Grid
                item
                xs={12}
                sm={5}
                md={4}
                lg={3}
                className={classNames({
                  'is-mobile-progress-circle': isMobile,
                })}>
                <div className="overall-progress-circle">
                  <PercentageCircle
                    color={overallProgress === 100 ? greenColor : goldColor}
                    percent={overallProgress}
                    radius={100}
                    borderWidth={12}>
                    <p className="overall-progress-verbiage">
                      {overallProgressWithPercentage}
                      <br />
                      <span>{intl.get('questionnaire.overAllProgress')}</span>
                    </p>
                  </PercentageCircle>
                </div>
              </Grid>
              <Grid item xs={12} sm={7} md={8} lg={9}>
                {whatYouNeedDescription}

                {showReadMoreBtn && (
                  <div className="show-mobile read-more-btn" onClick={toggleReadMore}>
                    <span className="space-after">{intl.get('questionnaire.read')}</span>
                    {readMore ? intl.get('questionnaire.less') : intl.get('questionnaire.more')}
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        )}

        {isWithinCaseDetails && (
          <div className="add-side-margins">
            <Grid container spacing={0}>
              <Grid item xs={2} className="text-center">
                <div className="overall-progress-circle">
                  <PercentageCircle
                    color={overallProgress === 100 ? greenColor : goldColor}
                    percent={overallProgress}
                    radius={50}
                    borderWidth={6}>
                    <p className="overall-progress-verbiage">{overallProgressWithPercentage}</p>
                  </PercentageCircle>
                </div>
              </Grid>
              <Grid item xs={5}>
                <h1>{intl.get('questionnaire.overAllProgress')}</h1>
                <div>
                  <p>{intl.get('questionnaire.caseId')}</p>
                  <p>{intl.get('questionnaire.location')}</p>
                </div>
              </Grid>
              <Grid item xs={5}>
                <div className="questionnaire-status">
                  <p>
                    <strong>{data.propertyNameDueDate}</strong>&nbsp;&nbsp;
                    {formatDDMMYY(data.valueDueDate)}
                  </p>
                  <p>
                    {data.questionnaireStatus && data.questionnaireStatus.includes('Unlocked') ? <LockOpenIcon /> : <LockIcon />}
                    &nbsp;&nbsp;
                    {data.statusMessage}
                  </p>
                </div>
              </Grid>
            </Grid>
          </div>
        )}
        {/* <hr /> */}
        <div className="add-side-margins">
          <div className="questionnaire-items">
            {data.menus &&
              data.menus.map((item, index) => {
                const sectionProgress = parsePercentString(item.sectionProgress);
                return <QuestionnaireAccordionSectionPres key={index} sectionProgress={sectionProgress} {...props} itemDetail={item} />;
              })}
          </div>
        </div>
      </article>
      <ActionsBarContainer onClose={onClose} />
    </div>
  );
};

export default QuestionnaireLandingPres;



// WEBPACK FOOTER //
// ./src/ui/features/Questionnaire/presentational/QuestionnaireLandingPres.js